import { ShieldCheck, EyeOff, Lock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { FadeUp } from "./Reveal";

const POINTS = [
  { icon: ShieldCheck, title: "No data selling", copy: "Your information is never sold, rented, or shared with third parties." },
  { icon: EyeOff, title: "No trackers", copy: "No ad trackers, no cross-app profiling, no hidden analytics." },
  { icon: Lock, title: "Locked down", copy: "Your data is encrypted in transit and at rest, always." },
];

export default function Privacy() {
  return (
    <section
      id="privacy"
      className="border-t border-[#111111]/10 px-6 md:px-12 py-24 md:py-32"
      data-testid="privacy-section"
    >
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <FadeUp>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#111111]/50">
              05 — Privacy · Last updated July 2026
            </p>
            <h2 className="font-serif font-light tracking-tight text-4xl md:text-5xl mt-6">
              Your data stays <em className="text-[#1F9D55]">yours.</em>
            </h2>
          </FadeUp>
        </div>
        <div className="md:col-span-8">
          <FadeUp delay={0.1}>
            <p className="text-base md:text-lg leading-relaxed text-[#111111]/75 max-w-2xl" data-testid="privacy-statement">
              We value your privacy. My Fresh Tracker never sells, rents, or shares your personal data with anyone.
              Your grocery list lives in your account — nowhere else. No advertisers, no data brokers, no fine print.
            </p>
            <div className="mt-12 grid sm:grid-cols-3 gap-px bg-[#111111]/10 border border-[#111111]/10">
              {POINTS.map((p) => (
                <div key={p.title} className="bg-[#F7F6F2] p-8">
                  <p.icon className="h-5 w-5 text-[#1F9D55]" />
                  <h3 className="mt-4 font-medium">{p.title}</h3>
                  <p className="mt-2 text-sm text-[#111111]/60 leading-relaxed">{p.copy}</p>
                </div>
              ))}
            </div>
            <p className="mt-8 font-mono text-xs text-[#111111]/50">
              Questions about privacy? Write to myfreshtracker@gmail.com
            </p>
            <Link
              to="/privacy"
              data-testid="privacy-full-policy-link"
              className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#16783F] hover:text-[#111111] transition-colors duration-300"
            >
              Read the full Privacy Policy <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
